import { Assistant } from "../../../../features/Assistants/components";
import { AssistantPage } from "../../../../pages/AssistantPage";
import { appRouterPaths } from "../../../../services/navigation/urls";
import type { AppRouteProps } from "../../types";

export const assistantsPageRouteConfig: AppRouteProps = {
  path: appRouterPaths.assistants.root,
  element: <AssistantPage />,
  name: "Ассистенты",
  children: appRouterPaths.assistants.item
    ? [
        {
          path: appRouterPaths.assistants.item,
          element: <Assistant />,
          name: "Ассистент",
        },
      ]
    : undefined,
};
